import { isEmpty, chain } from "lodash"
import PropTypes from "prop-types"
import { IconButton } from "@mui/material"
import { ExpandLess, ExpandMore, Remove, Add, TableView, BarChart } from "@mui/icons-material"
import CompareSelect from "components/material/compare-select"

export const MODES = {
  TOP_X: "topX",
  TABLE: "table",
}

function getGroup(availableGroups, optionId) {
  return chain(availableGroups)
    .map(({ options }) => options)
    .flatten()
    .keyBy("id")
    .get(optionId)
    .omit("label")
    .value()
}

export function GroupSelector({ availableGroups, name, selectedGroup, setSelectedGroup, buttonSize }) {
  return isEmpty(availableGroups) ? <span className="name">
    <span>{name}</span>
  </span>
    : <CompareSelect
        className="compare-table_group-selector"
        key="compare-select"
        options={availableGroups}
        selectedOption={selectedGroup}
        setSelected={(optionId) => {
          const selectedGroup = getGroup(availableGroups, optionId)
          setSelectedGroup(selectedGroup)
        }}
        slotProps={{
          popper: {
            placement: "top-end",
            style: {
              width: "fit-content",
            },
          },
        }}
        buttonSize={buttonSize}
    />
}

GroupSelector.propTypes = {
  availableGroups: PropTypes.array.isRequired,
  name: PropTypes.string.isRequired,
  selectedGroup: PropTypes.object.isRequired,
  setSelectedGroup: PropTypes.func.isRequired,
  buttonSize: PropTypes.string.isRequired,
}

export function ToggleExpanded({ expanded, toggleExpanded, buttonSize }) {
  return <IconButton
    size={buttonSize}
    className="expand-icon"
    onMouseDown={toggleExpanded}
  >
    {expanded ? <ExpandLess fontSize="inherit" /> : <ExpandMore fontSize="inherit" />}
  </IconButton>
}

ToggleExpanded.propTypes = {
  expanded: PropTypes.bool.isRequired,
  toggleExpanded: PropTypes.func.isRequired,
  buttonSize: PropTypes.string.isRequired,
}

export function ToggleAll({ showAllButton, expanded, all, toggleAll, buttonSize }) {
  return showAllButton && expanded && <IconButton
    size={buttonSize}
    className="show-all-icon"
    onMouseDown={toggleAll}
  >
    {all ? <Remove fontSize="inherit" /> : <Add fontSize="inherit" />}
  </IconButton>
}

ToggleAll.propTypes = {
  showAllButton: PropTypes.bool.isRequired,
  expanded: PropTypes.bool.isRequired,
  all: PropTypes.bool.isRequired,
  toggleAll: PropTypes.func.isRequired,
  buttonSize: PropTypes.string.isRequired,
}

export function ToggleDisplayMode({ mode, toggleDisplayMode, buttonSize }) {
  return <IconButton
    onMouseDown={toggleDisplayMode}
    className="table-toggle"
    size={buttonSize}
  >
    {mode === MODES.TOP_X ? <TableView fontSize="inherit" aria-label="Table view" /> : <BarChart fontSize="inherit" style={{ transform: "rotate(90deg)" }} aria-label="Bar chart view" />}
  </IconButton>
}

ToggleDisplayMode.propTypes = {
  mode: PropTypes.string.isRequired,
  toggleDisplayMode: PropTypes.func.isRequired,
  buttonSize: PropTypes.string.isRequired,
}
